"use client"

import { LinkIcon } from "@/icons/solid"
import { FloatingShareButton } from "./FloatingShareButton"
import { InstagramIcon } from "@/icons/solid/InstagramIcon"
import { LinkedInIcon } from "@/icons/solid/LinkedInIcon"
import Link from "next/link"
import { copyToClipboard } from "@/utils/copyToClipboard"

export const ShareStack = ({ articlePath }: { articlePath: string }) => {
  return (
    <div className="flex w-full flex-row gap-x-3">
      <FloatingShareButton onClick={() => copyToClipboard(articlePath)}>
        <LinkIcon className="size-5 fill-[#AA95D6] transition-all duration-300 group-hover:fill-[#9680C8]" />
      </FloatingShareButton>

      <Link href={`https://www.linkedin.com/shareArticle?mini=true&url=${articlePath}`}>
        <FloatingShareButton>
          <LinkedInIcon className="size-5 fill-[#AA95D6] transition-all duration-300 group-hover:fill-[#9680C8]" />
        </FloatingShareButton>
      </Link>
    </div>
  )
}
